// extracted by mini-css-extract-plugin
export var button = "Button-module--button--sNj6R";
export var materialIcons = "Button-module--material-icons--3dT8N";
export var buttonPrimary = "Button-module--buttonPrimary--G067A";
export var buttonSecondary = "Button-module--buttonSecondary--Hn2fh";
export var buttonTertiary = "Button-module--buttonTertiary--m+lRV";
export var buttonGhost = "Button-module--buttonGhost--sLpqf";